import WxmpRsa  from 'wxmp-rsa'

// RSA 公钥
const PUBLIC_KEY = `-----BEGIN rsa public key-----
MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAqbUep0nSNA9SD9fKV41t
W+jJ2k0gcF4K1KkTYhorfPG1TOOYisHihks+oJ8qbDSqErVUEjb+XOjofZfH84iX
zaKmEkc8CdUNuq9zsWrnDg8uyduvScidnXnnJOIa0WbveTJX5pVH5K1P8sts9Rkm
kdXzTIiY9aAQR7KbHV/2xlMUTc/9Bd0bC9VAPANLC1ramEQ5mTa5v/58VRnyCxff
ycdXrlEueWO6uBJS92TjDVf+jkc8Y+WhFFxHDip4NMblk9hQrMaEfhyzqEf5bff/
7ZVaZnm5DHIHa4uxSuhGWRBoFpyenNBqirR3Iz2ZQlgFX1O46DrJPWtivy85j4aG
xwIDAQAB
-----END rsa public key-----`

/**
 * RSA加密
 * @param {string} text 需要加密的文本
 * @returns {string} 返回BASE64编码的加密字符串
 */
export function rsaEncrypt(text) {
    try {
        // 创建RSA实例
        const rsa = new WxmpRsa()
        rsa.setPublicKey(PUBLIC_KEY);
        // 加密并返回base64编码的字符串
        return rsa.encryptLong(text)
    } catch (error) {
        console.error('RSA加密错误:', error)
        throw error
    }
} 